import { postingShow } from './api';
import { isRestrictedPosting } from './postingVisibilityValues';

// A company's job or RFP, read the way every page should read one. A posting kept to the company's
// preferred network is held back from the marketplace, so the marketplace answers it to no one but
// its author; the server answers it to the company's team and to the people the posting admits. The
// marketplace is asked first; a posting it does not answer, or answers in a state it serves to no one
// but the author, is read through the server, which decides on its own who may see it.

const AUTHOR_ONLY_STATES = ['draft', 'pendingApproval'];

const idOf = id => (id && typeof id === 'object' ? id.uuid : id);

// The server read takes the listing id and the image sizes a page asks for; it always includes the
// author and the images.
const serverParams = params =>
  Object.keys(params || {}).reduce(
    (acc, key) =>
      key === 'fields.image' || key.startsWith('imageVariant.') ? { ...acc, [key]: params[key] } : acc,
    { id: idOf(params && params.id) }
  );

const readThroughServer = params => postingShow(serverParams(params));

/** The marketplace's `listings.show`, for a job or RFP, with the server read where it is needed. */
export const showPostingListing = (sdk, params) =>
  sdk.listings.show(params).then(
    response =>
      AUTHOR_ONLY_STATES.includes(response?.data?.data?.attributes?.state) ? readThroughServer(params) : response,
    error => (error?.status === 404 ? readThroughServer(params) : Promise.reject(error))
  );

/**
 * A marketplace answer without the jobs and RFPs kept to a company's preferred network. Pages that
 * query the marketplace directly cannot tell who a posting admits, so they leave every such posting
 * out; the server search adds back the ones the searcher can see.
 */
export const withoutRestrictedPostings = response => {
  const listings = response?.data?.data;
  if (!Array.isArray(listings)) return response;
  return {
    ...response,
    data: { ...response.data, data: listings.filter(l => !isRestrictedPosting(l?.attributes?.publicData)) },
  };
};
